"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListAdapter = void 0;
const demarked_1 = require("@d24/demarked");
const adapter_1 = require("../_abstract/adapter");
const _contracts_1 = require("../_contracts");
const adapter_2 = require("../_helpers/adapter");
const List_helpers_1 = require("./List.helpers");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
class ListAdapter extends adapter_1.AbstractAdapter {
    /**
     * Adapts (translates/maps) the passed-in `ListModule` to the `ListToken`.
     *
     * @param object - The module to adapt.
     */
    objectToToken(object) {
        const { content } = object;
        // TMP
        // this.validate(content, {
        //   items: {
        //     presence: true,
        //     type: 'array'
        //   },
        //   meta: {
        //     presence: true
        //   },
        //   'meta.isLoose': {
        //     presence: true,
        //     type: 'boolean'
        //   },
        //   'meta.isOrdered': {
        //     presence: true,
        //     type: 'boolean'
        //   },
        //   'meta.start': {
        //     presence: true,
        //     type: { type: (value: unknown) => typeof value === 'string' || typeof value === 'number' }
        //   }
        // })
        let { items, meta } = content;
        const updateItems = (items) => {
            return items.map(item => {
                const _item = { ...item };
                _item.meta = {
                    isOrdered: false,
                    isLoose: false,
                    start: 1,
                    ...item.meta
                };
                if (item.children) {
                    item.children = updateItems(item.children);
                }
                return _item;
            });
        };
        items = updateItems(items);
        const token = {
            content: List_helpers_1.convertSLIsToLITs(items),
            meta: {
                // @ts-expect-error
                isLoose: false,
                // @ts-expect-error
                isOrdered: false,
                // @ts-expect-error
                start: '',
                // This line will overwrite any possible duplicates.
                ...meta
            },
            type: demarked_1.TokenType.List
        };
        token.raw = List_helpers_1.getListTokenRaw(token.content, typeof meta !== 'undefined' ? !!meta.isOrdered : false);
        return token;
    }
    /**
     * Adapts (translates/maps) the passed-in `ListToken` to the `ListModule`.
     *
     * @param token - The token to adapt.
     */
    tokenToObject(token) {
        const { content: children, meta } = token;
        this.validate(children, { presence: true, type: 'array' }, true);
        this.validate(meta, {
            isLoose: {
                presence: true,
                type: 'boolean'
            },
            isOrdered: {
                presence: true,
                type: 'boolean'
            },
            start: {
                presence: true,
                type: { type: (value) => typeof value === 'string' || typeof value === 'number' }
            }
        });
        return {
            ...adapter_2.getModuleBase(),
            content: {
                items: List_helpers_1.convertLITsToLIs(children),
                meta: meta
            },
            driver: _contracts_1.ModuleDriver.List
        };
    }
}
exports.ListAdapter = ListAdapter;
//# sourceMappingURL=List.adapter.js.map